import { Component, Input, OnInit } from '@angular/core';
import { Album } from '../../shared-api/albums/album.model';
import { Breadcrumb } from '../../shared-api/albums/breadcrumb.model';
import { Router } from '@angular/router';
import { Folder } from '../../shared-api/folders/folder.model';
import { FolderBreadcrumb } from '../../shared-api/folders/folder-breadcrumb.model';

@Component({
    selector: 'myapp-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: [ './breadcrumb.component.less' ]
})
export class BreadcrumbComponent implements OnInit
{
    @Input() album: Album;
    @Input() folder: Folder;

    constructor(private router: Router) { }

    ngOnInit()
    {
    }

    onBreadcrumbClicked(breadcrumb: Breadcrumb)
    {
        this.router.navigate([ '/folder', breadcrumb == null ? 0 : breadcrumb.Id ]);
    }

    onDocCenterBreadcrumbClicked(breadcrumb: FolderBreadcrumb)
    {
        this.router.navigate([ '/doc-center', breadcrumb == null ? 0 : breadcrumb.Id ]);
    }
}
